import React, { useEffect, useRef } from 'react'
import { PopularCourse } from './popularCourse';
import Footer from '../home/footer';
import { gsap } from 'gsap';

export function CoursesPage() {
    const containerRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);

        gsap.fromTo(containerRef.current,
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 0.8, ease: "power3.out" }
        );
    }, []);

    return (
        <>
            <div ref={containerRef} className='w-full text-center min-h-screen relative pt-[60px] overflow-hidden '>
                <div className='bg-pumpkinToast-500 mt-[60px] w-[400px] h-[400px] absolute blur-[160px] z-0 top-[100px] '></div>
                <div className='bg-pumpkinToast-500 mt-[60px] w-[400px] h-[400px] absolute blur-[160px] z-0 top-[150vh] right-0 '></div>
                <PopularCourse />
                {/* <CouseCategory /> */}
                {/* <div className=' flex flex-col gap-32 pt-8 pb-36'>
                <GetIdCard />
                <StaffTraining />
            </div> */}
                {/* <Success /> */}
            </div>
            <Footer />
        </>
    )
}
